import styled from 'styled-components';
import { CALYPSO_LIGHT, HEFFALUMP, OLAF, PANTERA } from 'HubStyleTokens/colors';
import UIIconButton from 'UIComponents/button/UIIconButton';

// Keeping UIIconButton for now until Breeze AI branding works with IconButton
export const ActionIconButton = styled(UIIconButton).withConfig({
  displayName: "ActionIconButton",
  componentId: "og0x9s-0"
})(["color:", " !important;background:", " !important;border:none !important;margin-left:0 !important;&:hover{background:", " !important;}"], ({
  selected
}) => selected ? OLAF : 'inherit', ({
  selected
}) => selected ? PANTERA : 'inherit', ({
  selected
}) => selected ? HEFFALUMP : CALYPSO_LIGHT);